// 枚举
export default {
  // 管理员类型
  type: [
    {
      id: 1,
      value: '超级管理员'
    },
    {
      id: 2,
      value: '普通管理员'
    },
    {
      id: 3,
      value: '普通用户'
    }
  ],
  // 运行 禁用 状态
  status: [
    {
      id: 0,
      value: '运行'
    },
    {
      id: 1,
      value: '禁用'
    },
  ]
}
